import React, { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useObserver } from 'mobx-react'
import OtherData from './OtherData.jsx'
import CreditsData from './CreditsData.jsx'
import ChargingData from './ChargingData.jsx'
import ReasonsTable from './ReasonsTable.jsx'

const StyledTabsWrapper = styled.div`
  .tab-content {
    margin-top: 25px;
  }
  .flexSpaceBetween{
    padding:10px;
    display: flex;
    justify-content: space-between;
  }
  .nav-tabs {
      background:none;
      .nav-item {
        .nav-link {
            font-weight: 500;
            color: black;
            border-radius: 0;
            padding-top:20px;
            margin-bottom:0;
            &:focus {
              outline: 0;
            }
            &:hover {
              border-color: transparent;
              color: ${props => props.theme.primaryColor};
            }
            &.active {
              background:none;
              border-left: 0;
              border-top: 0;
              border-right: 0;
              position: relative;
              &:after {
                content:"";
                height: 5px;
                width: calc(100% + 0px);
                display: block;
                background: ${props => props.theme.primaryColor};
                z-index: 10;
                position: absolute;
                bottom: -2.5px;
                left: 0;
                border-radius: 10px;
              }
            }
        }
      }
  }
`

const PositionTabs = ({ position, handleChangePositionByKey, formErrors, index }) => {
  const [activeTabKey, setActiveTabKey] = useState('')
  const { t } = useTranslation()

  const handleTabSelect = (eventKey) => {
    setActiveTabKey(eventKey)
  }

  return useObserver(() => (
    <StyledTabsWrapper>
      <Tabs id={`positions${index} tabs`} onSelect={handleTabSelect} activeKey={activeTabKey} className={`mt-2`} justify>
        <Tab eventKey="other" title={t('returnsProcessingPage:otherTab')} tabClassName="fw-bold" mountOnEnter unmountOnExit >
          <OtherData position={position} handleChangePositionByKey={handleChangePositionByKey} formErrors={formErrors} index={index} />
        </Tab>
        {!!position.credits.length &&
          <Tab eventKey="credits" title={t('returnsProcessingPage:creditsTab')} tabClassName="fw-bold" mountOnEnter unmountOnExit >
            <CreditsData position={position} handleChangePositionByKey={handleChangePositionByKey} formErrors={formErrors} index={index} />
          </Tab>
        }
        {!!position.charges.length &&
          <Tab eventKey="charging" title={t('returnsProcessingPage:chargingTab')} tabClassName="fw-bold" mountOnEnter unmountOnExit >
            <ChargingData position={position} handleChangePositionByKey={handleChangePositionByKey} formErrors={formErrors} index={index} />
          </Tab>
        }
        {!!position.selectedReturnReasons.length &&
          <Tab eventKey="reasons" title={t('complaints:returnReasons')} tabClassName="fw-bold" mountOnEnter unmountOnExit >
            <ReasonsTable position={position} handleChangePositionByKey={handleChangePositionByKey} />
          </Tab>
        }
      </Tabs>
    </StyledTabsWrapper >
  ))
}

export default PositionTabs
